import { Form, Button, Modal, FlexboxGrid, ButtonToolbar, toaster, Message, RadioGroup, Radio } from 'rsuite';
import { useHistory } from "react-router-dom";
import ReactDOM from 'react-dom/client';
import 'react-toastify/dist/ReactToastify.css';
import { useEffect, useState } from 'react';
import { changeAlternativeMobilePhoneAndEmail, getById } from 'services/microsoftGraphApi';
import React from 'react';
import CryptoJS from 'crypto-js';
import ClipLoader from 'react-spinners/ClipLoader';
import { RequestVM } from 'models/requestVM';

const regexMail = /^(([^<>()[\].,;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*)|(".+"))@(([^<>()[\].,;:\s@"]+\.)+[^<>()[\].,;:\s@"]{2,})$/i;
const regexPhone = /^(\+?56)?(\s?)(0?9)(\s?)[98765432]\d{7}$/i;

function ModificarRecuperacion(props) {  

  const [userName, setUserName] = useState();  
  const [amail, setAmail] = useState();
  const [mail, setMail] = useState();
  const [mailHidden, setMailHidden] = useState();
  const [mobilePhone, setMobilePhone] = useState();
  const [mobilaEphone, setMobilAEphone] = useState();
  const [mobilePhoneHidden, setMobilePhoneHidden] = useState();
  const [value, setValue] = useState();
  const [loadingInProgress, setLoading] = useState(false);
  const [openMail, setOpenMail] = React.useState(false);  
  const [openPhone, setOpenPhone] = React.useState(false);  
  const [isDisabledbutton, setDisibilityButton] = useState(true);
  const [isDisabledbuttonConfirm, setDisibilityButtonConfirm] = useState(true);

  const history = useHistory();

  const handleClose = () => {
    if(value == 'A')
    {
      setOpenMail(false);
    }
    else
    {
      setOpenPhone(false);
    }
  };
  
  const handleOpen = () => {
    if(value != null)
    {
      if(value == 'A')
      {
        setOpenMail(true);
      }
      else
      {
        setOpenPhone(true);
      }
    }
    else
    {
      toaster.push(
        <Message showIcon type="warning" header="Atención" duration={4000}>
            Debe seleccionar un método antes de continuar.
        </Message>, { placement: 'topEnd' });
     }
  };

  const handleChange = (val) => {
    setValue(val);
    setDisibilityButton(false);
  }; 

  const handleChangeMail = (val) => {
    setAmail(val);
    setDisibilityButtonConfirm(true);

        if (val != "")
        {
            if(regexMail.test(val))
            {
              setDisibilityButtonConfirm(false);
            }              
        } 
  }; 

  const handleChangePhone = (val) => {
    setMobilAEphone(val);
    setDisibilityButtonConfirm(true);

        if (val != "")
        {
            if(regexPhone.test(val))
            {
              setDisibilityButtonConfirm(false);
            }              
        } 
  };  
   
  const goBack = (() => {
    let path = '/tiposrecuperacion'; 
    history.push(path);
  });

  const readQueryParams = async () => {
    if (props.history != undefined)
    {
      const respuesta = props.history.location.pathname.replace('/modificacionrecuperacion/','');    
      // Decrypt
      var bytes = CryptoJS.AES.decrypt(respuesta, 'my-secret-key@123');
      var decryptedData = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
  
      if (decryptedData != null && decryptedData != undefined)
      {
        callMicrosoftGraphAPI(decryptedData);        
      }
      else {
        toaster.push(
          <Message showIcon type="warning" header="Atención" duration={4000}>
              Debe iniciar sesión.
          </Message>, { placement: 'topEnd' });
  
          goBack();
      }
    }  
  };

  useEffect(() => {    
    readQueryParams();    
  });  

  const callMicrosoftGraphAPI = async (id) => {

    const respuesta = await getById(id);

    if (respuesta.success)
    {
      let email = respuesta.data.mail;
      let emailHide = email.split("@")[0].length - 1;//<-- number of characters to hide
      var r = new RegExp(".{"+emailHide+"}@", "g");
      let emailHidden = email.replace(r, "***@" );

      let mobilePhone = respuesta.data.mobilePhone;      
      let mobilePhoneHidden = mobilePhone?.replace(/\d(?=.*\d{4})/g, "*");

      setUserName(respuesta.data.userPrincipalName);
      setMail(email);
      setMailHidden(emailHidden);
      setMobilePhone(mobilePhone);
      setMobilePhoneHidden(mobilePhoneHidden);
      
    }
    else {
      toaster.push(
        <Message showIcon type="warning" header="Atención" duration={4000}>
            No se encontró información para la cuenta usuario colaborador ingresada.
        </Message>, { placement: 'topEnd' });

      goBack();
    }
  };

  const callMicrosoftGraphAPI2 = async () => {   
      
    handleClose();
    setLoading(true);

    let model = new RequestVM(userName, "", "", value === "B" ? true: false, mobilePhone, mail);

    if(amail != null || mobilaEphone != null)
    {
      if(amail != null)
      {
        if(amail != userName)
        {
          model = new RequestVM(userName, "", "", value === "B" ? true: false, mobilePhone, amail);
        }
        else
        {
        toaster.push(
          <Message showIcon type="warning" header="Atención" duration={4000}>
              Es su correo principal. Debe ingresar un correo alternativo
          </Message>, { placement: 'topEnd' });
          
          setLoading(false);
          let limpia;
          setAmail(limpia);
          setMobilAEphone(limpia);
          return;
        }
      }

      if(mobilaEphone != null)
      {
        model = new RequestVM(userName, "", "", value === "B" ? true: false, mobilaEphone, mail);
      }      
      
      const respuesta = await changeAlternativeMobilePhoneAndEmail(model);

      if (respuesta.success) {

        setLoading(false);

        toaster.push(
          <Message showIcon type="success" header="Atención" duration={4000}>
              Se ha modificado correctamente el método de recuperación seleccionado.
          </Message>, { placement: 'topEnd' });

        goBack();
      }
      else 
      {
        setLoading(false);

        toaster.push(
          <Message showIcon type="error" header="Atención" duration={4000}>
              No se ha podido modificar el método de recuperacion seleccionado.
          </Message>, { placement: 'topEnd' });        
      }   
    }
    else
    {
      toaster.push(
        <Message showIcon type="warning" header="Atención" duration={4000}>
            Debe seleccionar un método de recuperación
        </Message>, { placement: 'topEnd' });
    }
  };  

  const renderModificarRecuperacion = (
    <Form layout="vertical">
      <RadioGroup name="radioList">
        <p>Opciones de modificación</p>
          <Radio value="A" onChange={handleChange}>Correo Electrónico Alternativo: { mailHidden }</Radio>                
          <Radio value="B" onChange={handleChange}>SMS a N° Móvil: { mobilePhoneHidden }</Radio>    
      </RadioGroup>  
      <ButtonToolbar style={{ marginTop: '5%', textAlign: 'right' }}>  
        <Button appearance='primary' color='blue' disabled={isDisabledbutton} onClick={handleOpen}>Modificar</Button>
        <Button appearance='subtle' color='green' onClick={goBack}>Volver</Button>
      </ButtonToolbar>  
    </Form>
  );

  return (
    <FlexboxGrid justify="center" align="middle" style={{ marginTop: '5%', backgroundColor: '#FFF' }}>  
      {loadingInProgress ? (<ClipLoader color={'#000000'} size={150} />) : (renderModificarRecuperacion)}                
        <>    
          <Modal open={openMail} onClose={handleClose} size="xs">
            <Modal.Header>
              <Modal.Title>Modificar Correo Electrónico Alternativo</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <Form>
                <Form.Group controlId="email">
                  <Form.ControlLabel>Nuevo Correo Electrónico Alternativo</Form.ControlLabel>
                  <Form.Control value={amail} onChange={handleChangeMail} name="correo"/>
                </Form.Group>                 
              </Form>
            </Modal.Body>
            <Modal.Footer>
              <ButtonToolbar style={{ marginTop: '5%', textAlign: 'right' }}>  
                <Button appearance="primary" disabled={isDisabledbuttonConfirm} color='blue' type="submit" onClick={callMicrosoftGraphAPI2}>
                  Confirmar
                </Button>              
              </ButtonToolbar>        
            </Modal.Footer>
          </Modal>
          <Modal open={openPhone} onClose={handleClose} size="xs">
            <Modal.Header>
              <Modal.Title>Modificar N° Móvil</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <Form>            
                <Form.Group controlId="phone">
                  <Form.ControlLabel>Nuevo N° Móvil</Form.ControlLabel>
                  <Form.Control value={mobilaEphone} onChange={handleChangePhone} name="movil" />
                </Form.Group>            
              </Form>
            </Modal.Body>
            <Modal.Footer>
              <ButtonToolbar style={{ marginTop: '5%', textAlign: 'right' }}>  
                <Button appearance="primary" disabled={isDisabledbuttonConfirm} color='blue' type="submit" onClick={callMicrosoftGraphAPI2}>
                  Confirmar
                </Button>              
            </ButtonToolbar>        
            </Modal.Footer>
          </Modal>      
        </>
    </FlexboxGrid>
  );

}

const rootElement = document.getElementById('root');

const root = ReactDOM.createRoot(rootElement);

root.render(<ModificarRecuperacion/>);

export default ModificarRecuperacion;